export default __webpack_public_path__ + "assets/images/7261354d3c59278e5ccee5a1d017ce1d.gif";